export const getFlagEmoji = countryCode => {
  if (!countryCode) return ''

  return String.fromCodePoint(
    ...[...countryCode.toUpperCase()].map(x => 0x1f1a5 + x.charCodeAt())
  )
}



// WEBPACK FOOTER //
// ./scripts/shared/flag-emoji.js